import React, { useEffect } from "react";
import { useSetting } from "store/settings";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { Loading, TextArea, TextField } from "components/form";
import { GalleryField } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
const Other = (props) => {
  const { dispatch, getSetting, submitSetting, other, loading } = useSetting();
  const key = "other";
  useEffect(() => {
    dispatch(getSetting(key));
  }, []);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <Formik
        initialValues={other || {}}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: values, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات متفرقه</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    label="تصویر بک گراند عمومی:"
                    name="general_bg"
                    component={GalleryField}
                    dataType="url"
                  />
                  <Field
                    label="تصویر (تماس با ما):"
                    name="contact_us_bg"
                    component={GalleryField}
                    dataType="url"
                  />
                  <Field
                    label="تصویر (درباره ما):"
                    name="about_us_bg"
                    component={GalleryField}
                    dataType="url"
                  />
                  <Field
                    label="تصویر (قوانین و مقررات):"
                    name="conditions_roles_bg"
                    component={GalleryField}
                    dataType="url"
                  />
                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Other;
